<app-main-nav></app-main-nav>
<app-side-nav></app-side-nav>

<div class="changelog-page" id="page">

    @if (pageLoading) {
        <div class="page-loader"><span>Loading...</span></div>
    } @else {
        <div class="changelog-container">
            <div class="changelog-header">
                <h1>Changelog</h1>
                <div class="filter-container">
                    <p-dropdown [options]="filterOptions" [(ngModel)]="selectedFilter"
                                optionLabel="label" (onChange)="onFilterChange()"
                                styleClass="changelog-filter">
                    </p-dropdown>
                </div>
            </div>

            @if (changelogs.length > 0) {
                <div class="changelog-list">
                    <h2>Recent Changes</h2>
                    <div class="changelog-grid">
                        @for (item of changelogs; track item.id) {
                            <div class="changelog-card"> <div class="card-header">
                                <h3>{{ item.title }}</h3>
                                @if (item.versionnumber) {
                                    <span class="version-badge">{{ item.versionnumber }}</span>
                                }
                            </div>
                                <div class="card-content">
                                    <div class="meta-info card-meta-info"> @if (item.date) {
                                        <span class="date">
                                                <i class="pi pi-calendar"></i>
                                            {{ item.date | date:'dd.MM.yyyy' }}
                                            </span>
                                    }
                                        <span class="area-badge area-1"> Released
                                        </span>
                                    </div>
                                    <div class="description" [innerHTML]="item.description || 'No description available'"></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            @if (futureFunctions.length > 0) {
                <div class="future-functions-list">
                    <h2>Upcoming Features</h2>
                    <div class="changelog-grid">
                        @for (item of futureFunctions; track item.id) {
                            <div class="changelog-card future"> <div class="card-header">
                                <h3>{{ item.title }}</h3>
                                <span class="label-planned">Planned</span>
                                @if (item.versionnumber) { <span class="version-badge version-badge-planned">{{ item.versionnumber }}</span>
                                }
                            </div>
                                <div class="card-content">
                                    <div class="meta-info card-meta-info"> @if (item.date) {
                                        <span class="date">
                                                <i class="pi pi-calendar"></i>
                                                Expected: {{ item.date | date:'dd.MM.yyyy' }}
                                            </span>
                                    }
                                    </div>
                                    <div class="description" [innerHTML]="item.description || 'No description available'"></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            @if (changelogs.length === 0 && futureFunctions.length === 0 && !pageLoading) {
                <div class="no-data">
                    <i class="pi pi-info-circle"></i>
                    <p>No changelogs available for the selected filter.</p>
                </div>
            }
        </div>
    }
</div>
